/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateReferralRecipientConfigRequest
 */
export interface UpdateReferralRecipientConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateReferralRecipientConfigRequest
     */
    provider_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferralRecipientConfigRequest
     */
    display_name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferralRecipientConfigRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferralRecipientConfigRequest
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferralRecipientConfigRequest
     */
    notes?: string;
    /**
     * Provider directory contact to resolve this recipient's email from at send time. Only applicable when provider_id resolves to an internal (ExaCare) provider; the contact must be contact_type 'inbound' for that provider.
     * @type {string}
     * @memberof UpdateReferralRecipientConfigRequest
     */
    contact_id?: string;
}

/**
 * Check if a given object implements the UpdateReferralRecipientConfigRequest interface.
 */
export function instanceOfUpdateReferralRecipientConfigRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateReferralRecipientConfigRequestFromJSON(json: any): UpdateReferralRecipientConfigRequest {
    return UpdateReferralRecipientConfigRequestFromJSONTyped(json, false);
}

export function UpdateReferralRecipientConfigRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReferralRecipientConfigRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'provider_id': !exists(json, 'provider_id') ? undefined : json['provider_id'],
        'display_name': !exists(json, 'display_name') ? undefined : json['display_name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'contact_id': !exists(json, 'contact_id') ? undefined : json['contact_id'],
    };
}

export function UpdateReferralRecipientConfigRequestToJSON(value?: UpdateReferralRecipientConfigRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'provider_id': value.provider_id,
        'display_name': value.display_name,
        'email': value.email,
        'phone': value.phone,
        'notes': value.notes,
        'contact_id': value.contact_id,
    };
}

